import { useEffect, useState } from 'react';
import { ordersApi, type OrderDashboard } from '../../api/orders';

export function OrderAnalyticsPage() {
  const [dashboard, setDashboard] = useState<OrderDashboard | null>(null);

  useEffect(() => {
    void ordersApi.dashboard().then(setDashboard);
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold">Order Analytics</h1>
      {dashboard && (
        <div className="mt-6 space-y-6">
          <p className="text-sm">Average health score: <strong>{dashboard.avg_health_score.toFixed(1)}</strong></p>
          <div>
            <h2 className="font-medium">By source</h2>
            <ul className="mt-2 text-sm">{Object.entries(dashboard.by_source).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
          </div>
          <div>
            <h2 className="font-medium">By status</h2>
            <ul className="mt-2 text-sm">{Object.entries(dashboard.by_status).map(([k, v]) => <li key={k}>{k}: {v}</li>)}</ul>
          </div>
        </div>
      )}
    </div>
  );
}
